import React from "react";
import { hydrate, render } from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";

import { ConfigProvider, message } from "antd";
import koKR from "antd/lib/locale/ko_KR";
import moment from "moment";
import "./index.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import "@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css";
import "@toast-ui/editor/dist/i18n/ko-kr";

import { PersistGate } from "redux-persist/integration/react";
import "dayjs/locale/ko";
import "moment/locale/ko";

import App from "./App";
import configureStore from "./redux/store/configureStore";

moment.locale("ko");
// const relativeTime = require('dayjs/plugin/relativeTime')
// dayjs.extend(relativeTime)
// dayjs.locale('ko')

const configStore = configureStore();

message.config({
	maxCount: 1,
	duration: 1,
});

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
	hydrate(
		<React.StrictMode>
			<Provider store={configStore.store}>
				<PersistGate persistor={configStore.persistor}>
					<HelmetProvider>
						<ConfigProvider locale={koKR}>
							<App />
						</ConfigProvider>
					</HelmetProvider>
				</PersistGate>
			</Provider>
		</React.StrictMode>,
		rootElement
	);
} else {
	render(
		<React.StrictMode>
			<Provider store={configStore.store}>
				<PersistGate persistor={configStore.persistor}>
					<HelmetProvider>
						<ConfigProvider locale={koKR}>
							<App />
						</ConfigProvider>
					</HelmetProvider>
				</PersistGate>
			</Provider>
		</React.StrictMode>,
		rootElement
	);
}

// ReactDOM.render(
//     <React.StrictMode>
//         <Provider store={configStore.store}>
//             <PersistGate persistor={configStore.persistor}>
//                 <App/>
//             </PersistGate>
//         </Provider>
//     </React.StrictMode>,
//     document.getElementById('root')
// );
